<script setup>
import { Icon } from '@iconify/vue';
import DashboardWidgetCard from './DashboardWidgetCard.vue';

defineProps({
    files: {
        type: Array,
        default: () => [],
    },
    loading: {
        type: Boolean,
        default: false,
    },
    error: {
        type: String,
        default: null,
    },
});

const emit = defineEmits(['preview', 'reload']);

const formatLocalDate = (dateStr) => {
    if (!dateStr) return '-';
    const [y, m, d] = dateStr.split('-');
    return `${d}/${m}/${y}`;
};
</script>

<template>
    <DashboardWidgetCard
        title="Documentos de Nivel"
        subtitle="Archivos y recursos compartidos para tu grado"
        icon="tabler:folder"
        iconColor="blue"
        :badge="files.length ? files.length : null"
        badgeColor="blue"
        :loading="loading"
        :error="error"
        :empty="!files.length"
        emptyMessage="No tienes documentos asignados en este momento."
        @reload="emit('reload')"
    >
        <div class="space-y-2.5">
            <div
                v-for="file in files"
                :key="file.id"
                class="flex items-center justify-between p-3 rounded-xl border border-gray-100 dark:border-slate-800 bg-gray-50/70 dark:bg-slate-800/40 hover:bg-white dark:hover:bg-slate-800 transition hover:shadow-xs group"
            >
                <div class="flex items-center min-w-0 pr-3 gap-3">
                    <div
                        class="w-9 h-9 rounded-xl flex items-center justify-center shrink-0"
                        :class="file.filename && file.filename.toLowerCase().endsWith('.pdf') ? 'bg-rose-100/70 text-rose-600 dark:bg-rose-950/40 dark:text-rose-400' : 'bg-blue-100/70 text-blue-600 dark:bg-blue-950/40 dark:text-blue-400'"
                    >
                        <Icon
                            :icon="file.filename && file.filename.toLowerCase().endsWith('.pdf') ? 'tabler:file-type-pdf' : 'tabler:file-text'"
                            class="w-5 h-5"
                        />
                    </div>
                    <div class="truncate">
                        <p class="text-xs sm:text-sm font-semibold text-gray-800 dark:text-gray-200 truncate group-hover:text-blue-600 transition">
                            {{ file.name }}
                        </p>
                        <div class="flex flex-wrap items-center gap-2 mt-0.5">
                            <span v-if="file.end_date" class="text-[11px] text-gray-500 dark:text-gray-400 flex items-center gap-1 font-normal">
                                <Icon icon="tabler:calendar-event" class="w-3.5 h-3.5 text-amber-500" />
                                Vigente hasta: {{ formatLocalDate(file.end_date) }}
                            </span>
                            <span v-if="file.description" class="text-[11px] text-gray-400 truncate max-w-[200px]">
                                · {{ file.description }}
                            </span>
                        </div>
                    </div>
                </div>

                <button
                    type="button"
                    @click="emit('preview', file)"
                    class="shrink-0 inline-flex items-center gap-1.5 px-3 py-1.5 bg-blue-600 hover:bg-blue-700 active:scale-95 text-white rounded-xl text-xs font-semibold shadow-xs transition"
                    title="Ver documento"
                >
                    <Icon icon="tabler:eye" class="w-4 h-4" />
                    <span class="hidden xs:inline">Ver</span>
                </button>
            </div>
        </div>
    </DashboardWidgetCard>
</template>
